import * as React from 'react';
import {
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   Text,
   IconButton,
   Tooltip,
   MenuItemProps,
} from '@chakra-ui/react';
import { tiptapButtonStyle } from './TiptapButton';
import { useEditorContext } from '../editor_context';
import { useLocalization } from '~/framework';
import { shadow } from '@dozuki/web-js/primitives';
import { faParagraph, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DropdownItem = (props: MenuItemProps) => {
   return (
      <MenuItem height={16} {...props}>
         {props.children}
      </MenuItem>
   );
};

export const TextStyleDropdown = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   const headingStyle = {
      fontSize: '4xl',
      fontWeight: 700,
      color: 'gray.900',
   };

   const subheadingStyle = {
      fontSize: '2xl',
      fontWeight: 600,
      color: 'gray.600',
   };

   const paragraphStyle = {
      fontSize: 'md',
   };

   return (
      <Menu onClose={() => setTimeout(() => editor.commands.focus(), 50)}>
         <Tooltip placement="top-start" label={_js('Text style')}>
            <MenuButton
               as={IconButton}
               icon={<FontAwesomeIcon icon={faParagraph} />}
               // @ts-ignore (MenuButton is missing a TS definition for the rightIcon prop)
               // See https://github.com/chakra-ui/chakra-ui/issues/231
               rightIcon={<FontAwesomeIcon icon={faChevronDown} />}
               padding={1}
               {...tiptapButtonStyle}
            />
         </Tooltip>
         <MenuList padding={0} boxShadow={shadow[3]}>
            <DropdownItem
               isDisabled={
                  editor.isActive('heading', { level: 2 }) || !editor.can().setHeading({ level: 2 })
               }
               onClick={() => editor.chain().setHeading({ level: 2 }).run()}
            >
               <Text {...headingStyle}>
                  {
                     /* Translators: "heading" as in the text at the top of a page */
                     _js('Heading')
                  }
               </Text>
            </DropdownItem>
            <DropdownItem
               isDisabled={
                  editor.isActive('heading', { level: 3 }) || !editor.can().setHeading({ level: 3 })
               }
               onClick={() => editor.chain().setHeading({ level: 3 }).run()}
            >
               <Text {...subheadingStyle}>
                  {
                     /* Translators: "subheading" as in a secondary header on the top of a page */
                     _js('Subheading')
                  }
               </Text>
            </DropdownItem>
            <DropdownItem
               isDisabled={editor.isActive('paragraph') || !editor.can().setParagraph()}
               onClick={() => editor.chain().setParagraph().run()}
            >
               <Text {...paragraphStyle}>
                  {
                     /* Translators: "paragraph" as in regular text */
                     _js('Paragraph')
                  }
               </Text>
            </DropdownItem>
         </MenuList>
      </Menu>
   );
};
